/**
 * App mode detection.
 *
 * Hub pivot (2026-08-02): tomlane.space is personal-studio only.
 * dontdatetom.com is a separate Vercel project (`~/dating`).
 * Dating-mode branch kept for local/dev host overrides only.
 */

export type AppMode = 'personal' | 'dating';

let _mode: AppMode | null = null;

export function getAppMode(): AppMode {
  if (_mode) return _mode;
  const host = window.location.hostname;
  // Production dating is no longer this SPA — only honor explicit local override.
  const forceDating =
    host === 'dontdatetom.com' ||
    host === 'www.dontdatetom.com' ||
    new URLSearchParams(window.location.search).get('mode') === 'dating';
  _mode = forceDating ? 'dating' : 'personal';
  return _mode;
}
